<template lang="pug">
  .div.is-pulled-right
    .control
      .tags.has-addons
        span.tag.is-dark.is-large(
          @mouseover="cambiarHover(true)"
          )
          | Agregados
        router-link.span.tag.is-primary.is-large(to="/Inventario/ListaSalida") 
          | {{ articulos_Salida.length}} 
          | &nbsp
          i.fas.fa-share-alt
      
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CarritoSalida',
  data () {
    return {
      hover: false
    }
  },
  methods: {
    cambiarHover (valor) {
      this.hover = valor
      this.$emit('hover', this.hover)
    }
  },
  computed: {
    ...mapState(['articulos_Salida'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inventario_Componentes/CarritoSalida.vue